import { useMemo, useEffect } from "react";

function InfiniteLoader({ show, message, actionOnShow, extras = {} } : any) {
    const intersectionOptions = useMemo(() => {
		return {
			root: null,
			rootMargin: '0px',
			threshold: 0
		}
	}, []);

    useEffect(() => {
		const loader = document.getElementById('inifinte-loader');
		const observer = new IntersectionObserver(intersectionCallback, intersectionOptions);
		if (loader)
			observer.observe(loader);

		return () => {
			if (loader)
				observer.unobserve(loader);
		}
	}, [extras])	

    const intersectionCallback = (entries: any) => {
		entries.forEach((entry: any) => {
			if(entry.isIntersecting) {
                actionOnShow()
            }
		})
	}

    return (
        <>
            {
                show &&
                <small id="inifinte-loader" className="text-theme-orange"> {message} </small>
            }
        </>
    )
}

InfiniteLoader.defaultProps = {
    show : false,
    message : 'loading more...'
}

export default InfiniteLoader